/**
 * Returns a formatted Date string in format 'Oct 4, 2019'
 * @param {Date} date - instance of the Date object
 * @returns {String} formatted string with date
 */
const getFormattedDate = (date) =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);

/**
 * Converts a Date object into a "time ago" string
 * @param {Date} date - instance of the Date object
 * @returns {String} formatted string representing the "time ago"
 */
export const toTimeAgo = (date) => {
  const nowUnix = Date.now() / 1000;
  const timeDiffUnix = nowUnix - date.valueOf() / 1000;
  let timeAgo;

  // less than an hour
  if (timeDiffUnix < 3600) {
    const timeDiffMin = Math.round(timeDiffUnix / 60);

    if (timeDiffMin < 2) {
      timeAgo = '1 minute ago';
    } else {
      timeAgo = timeDiffMin + ' minutes ago';
    }
  } else if (timeDiffUnix < 3600 * 24) {
    // less than 24 hours
    const timeDiffHour = Math.round(timeDiffUnix / 3600);

    if (timeDiffHour < 2) {
      timeAgo = '1 hour ago';
    } else {
      timeAgo = timeDiffHour + ' hours ago';
    }
  } else {
    // more than 24 hours
    timeAgo = 'on ' + getFormattedDate(date);
  }

  return timeAgo;
};

export const getUserName = (actor) =>
  actor.display_name || actor.username || 'Somebody';
